"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconAlert', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8 7.25C8.41421 7.25 8.75 7.58579 8.75 8V9.72722C8.75 10.1414 8.41421 10.4772 8 10.4772 7.58579 10.4772 7.25 10.1414 7.25 9.72722V8C7.25 7.58579 7.58579 7.25 8 7.25zM8 12.5085C8.41421 12.5085 8.75 12.1727 8.75 11.7585 8.75 11.3443 8.41421 11.0085 8 11.0085 7.58579 11.0085 7.25 11.3443 7.25 11.7585 7.25 12.1727 7.58579 12.5085 8 12.5085z', 'M8 2C8.36594 2 8.70266 2.19989 8.8779 2.52115L14.8779 13.5211C15.0469 13.831 15.0401 14.207 14.8599 14.5105C14.6797 14.814 14.3529 15 14 15H2C1.64706 15 1.32026 14.814 1.1401 14.5105C0.95994 14.207 0.9531 13.831 1.1221 13.5211L7.1221 2.52115C7.29734 2.19989 7.63406 2 8 2ZM12.3155 13L8 5.08833L3.68454 13H12.3155Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M10 8C10.5523 8 11 8.44772 11 9V12C11 12.5523 10.5523 13 10 13 9.44771 13 9 12.5523 9 12V9C9 8.44772 9.44771 8 10 8zM10 15.5C10.5523 15.5 11 15.0523 11 14.5 11 13.9477 10.5523 13.5 10 13.5 9.44771 13.5 9 13.9477 9 14.5 9 15.0523 9.44771 15.5 10 15.5z', 'M10 2C10.3589 2 10.6902 2.19229 10.8682 2.50386L18.8682 16.5039C19.0451 16.8134 19.0438 17.1936 18.8649 17.5019C18.686 17.8102 18.3565 18 18 18H2C1.64353 18 1.31401 17.8102 1.13509 17.5019C0.956168 17.1936 0.954898 16.8134 1.13176 16.5039L9.13176 2.50386C9.3098 2.19229 9.64114 2 10 2ZM16.2768 16L10 5.01556L3.72318 16H16.2768Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12 10C12.5523 10 13 10.4477 13 11V15C13 15.5523 12.5523 16 12 16 11.4477 16 11 15.5523 11 15V11C11 10.4477 11.4477 10 12 10zM12 19C12.5523 19 13 18.5523 13 18 13 17.4477 12.5523 17 12 17 11.4477 17 11 17.4477 11 18 11 18.5523 11.4477 19 12 19z', 'M12 2C12.3632 2 12.6978 2.19689 12.8742 2.51436L22.8742 20.5144C23.0462 20.8241 23.0416 21.2017 22.8619 21.5071C22.6822 21.8125 22.3543 22 22 22H2C1.64568 22 1.31781 21.8125 1.13813 21.5071C0.958444 21.2017 0.95377 20.8241 1.12584 20.5144L11.1258 2.51436C11.3022 2.19689 11.6368 2 12 2ZM20.3005 20L12 5.05913L3.69951 20H20.3005Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16 11.5C16.8284 11.5 17.5 12.1716 17.5 13V19C17.5 19.8284 16.8284 20.5 16 20.5 15.1716 20.5 14.5 19.8284 14.5 19V13C14.5 12.1716 15.1716 11.5 16 11.5zM16 25C16.8284 25 17.5 24.3284 17.5 23.5 17.5 22.6716 16.8284 22 16 22 15.1716 22 14.5 22.6716 14.5 23.5 14.5 24.3284 15.1716 25 16 25z', 'M16 2C16.5466 2 17.05 2.29735 17.3138 2.77609L30.8138 27.2761C31.0698 27.7408 31.0613 28.3061 30.7915 28.7629C30.5216 29.2197 30.0306 29.5 29.5 29.5H2.5C1.96945 29.5 1.47837 29.2197 1.20852 28.7629C0.938666 28.3061 0.930197 27.7408 1.18624 27.2761L14.6862 2.77609C14.95 2.29735 15.4534 2 16 2ZM26.9608 26.5L16 6.60813L5.03918 26.5H26.9608Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;